import { useState } from "react"
import { Route, Redirect } from "react-router-dom"
import { useAppSelector } from "./hooks"

function LoginRoute({ children, ...rest }) {
  const { userInfo } = useAppSelector((state) => state["appReducer"])
  const [initAuth] = useState(userInfo.authenticated)

  return (
    <Route
      {...rest}
      render={({ location }) => {
        return !initAuth ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location }
            }}
          />
        )
      }}
    />
  )
}

export default LoginRoute
